import React from 'react';
import { SectionCta } from '../ui/section-cta';

// eslint-disable-next-line import/prefer-default-export
export function Cta() {
  return <SectionCta primaryLink="/employer/signup" secondaryLink="/recruiter/signup" />;
}
